import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useDeviceSession } from "./application/hooks/useDeviceSession";
import AppLayout from "./presentation/layouts/AppLayout";
import PosPage from "./presentation/pages/PosPage";
import HistoryPage from "./presentation/pages/HistoryPage";
import SettingsPage from "./presentation/pages/SettingsPage";
import PairingPage from "./presentation/pages/PairingPage";
import PaymentPage from "./presentation/pages/PaymentPage";
import ConfirmationPage from "./presentation/pages/ConfirmationPage";
import DashboardPage from "./presentation/pages/DashboardPage";
import AdminLayout from "./presentation/layouts/AdminLayout";
import AdminLoginPage from "./presentation/pages/admin/AdminLoginPage";
import AdminReportsPage from "./presentation/pages/admin/AdminReportsPage";
import AdminCatalogPage from "./presentation/pages/admin/AdminCatalogPage";
import AdminTerminalsPage from "./presentation/pages/admin/AdminTerminalsPage";
import AdminWalletPage from "./presentation/pages/admin/AdminWalletPage";
import AdminMembersPage from "./presentation/pages/admin/AdminMembersPage";
import AdminSettingsPage from "./presentation/pages/admin/AdminSettingsPage";

export default function App() {
  const { paired, loading, pair } = useDeviceSession();

  // El área /admin (JWT de usuario) vive fuera del gate de pareo: son dos sesiones
  // distintas a propósito — la caja queda emparejada en el mostrador y el dueño entra al
  // panel desde otro lado.
  if (window.location.pathname.startsWith("/admin")) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminReportsPage />} />
            <Route path="catalogo" element={<AdminCatalogPage />} />
            <Route path="terminales" element={<AdminTerminalsPage />} />
            <Route path="wallet" element={<AdminWalletPage />} />
            <Route path="miembros" element={<AdminMembersPage />} />
            <Route path="ajustes" element={<AdminSettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </BrowserRouter>
    );
  }

  if (loading) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-bg-primary">
        <p className="text-text-secondary">Cargando...</p>
      </div>
    );
  }

  // If PIN is set but not authenticated, show login
  // Sin terminal emparejada no hay tenant, así que no hay nada que mostrar: ni el catálogo
  // ni las ventas existen fuera de un comercio.
  if (!paired) {
    return (
      <BrowserRouter>
        <PairingPage
          onPair={async (code, nombre) => {
            const err = await pair(code, nombre);
            if (!err) window.location.replace("/pos");
            return err;
          }}
        />
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AppLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/pos" element={<PosPage />} />
          <Route path="/pos/pay" element={<PaymentPage />} />
          <Route path="/pos/confirmed" element={<ConfirmationPage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/pos" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
